
import React from 'react';
import AdminContext from '../../StateContext/Application';
import { apiurl } from '../../../../path';
import { useContext } from 'react';
import { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Polyline, Popup, Circle, Rectangle, Polygon, useMapEvent, useMapEvents, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl:
        'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
    iconUrl:
        'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
    shadowUrl:
        'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});



const ShowMapProgressReport = () => {
    const context = useContext(AdminContext);
    const { id } = useParams();
    const { CreateMapCoordinateforProposal } = context;
    const nav = useNavigate();

    const [clickPositions, setClickPositions] = useState([]);
    // const [FetchedCoordinates, setFetchedCoordinates] = useState([]);
    const [selectedCoordinates, setSelectedCoordinates] = useState([]);
    const [progressReportCoordinates, setProgressReportCoordinates] = useState([]);
    const [techPoints, setTechPoints] = useState([]);
    const [selectedImage, setSelectedImage] = useState();

    const [mapCenter, setMapCenter] = useState([18.5615, 73.7685]);





    let polygonPositions = [];

    if (clickPositions.length === 2) {
        const startPosition = clickPositions[0];
        const endPosition = clickPositions[1];

        // Calculate direction and perpendicular vectors
        const dx = endPosition[1] - startPosition[1];
        const dy = endPosition[0] - startPosition[0];
        const length = Math.sqrt(dx * dx + dy * dy);
        const ux = -dy / length;
        const uy = dx / length;

        // Calculate polygon corners
        const roadWidth = 0.0002; // adjust width
        const corner1 = [startPosition[0] + ux * 0.0002, startPosition[1] + uy * 0.0006];
        const corner2 = [startPosition[0] - ux * 0.0000, startPosition[1] - uy * 0.0014];
        const corner3 = [endPosition[0] - ux * 0.0003, endPosition[1] - uy * 0.0009];
        const corner4 = [endPosition[0] + ux * 0.0000, endPosition[1] + uy * 0.0009];
        polygonPositions = [corner1, corner2, corner3, corner4];
    }



    const fetchCoordinatesfromtable = async () => {
        try {
            // let res = await CreateMapCoordinateforProposal("FetchAllCoordinatefromTable");
            let res2 = await CreateMapCoordinateforProposal("FetchSpecificCoordinateforProgressReport", id);
            // console.log(res);
            // setFetchedCoordinates(res);
            setSelectedCoordinates(res2.technicalSanction);
            setProgressReportCoordinates(res2.Progess)

            if (2 && res2.length > 0) {
                const firstPolygon = res2[0].Area;
                if (firstPolygon && firstPolygon.length > 0) {
                    setMapCenter(firstPolygon[0]);
                }
            }

            if (res2 && res2.length > 0) {
                setTechPoints(res2[0].TechnicalSanctionArea);
            }
        }
        catch (err) {
            console.error(err);
        }
    }



    useEffect(() => {
        fetchCoordinatesfromtable();
    }, []);


    const FlyToCenter = ({ center }) => {
        const map = useMap();
        useEffect(() => {
            if (center) {
                map.flyTo(center, 14); // Zoom to level 17
            }
        }, [center, map]);
        return null;
    }


    const groupedProgress = progressReportCoordinates.reduce((acc, item) => {
        if (!item.Location || !Array.isArray(item.Location) || item.Location.length < 2) {
            return acc; // skip bad item
        }

        const key = `${item.Location[0]}-${item.Location[1]}`;
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(item);
        return acc;
    }, {});

    // styling 
    const greenIcon = new L.Icon({
        iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-green.png',
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41],
    });

    const redIcon = new L.Icon({
        iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png',
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
        iconSize: [30, 45],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [45, 45],
    });



    const SatelliteLayerSwitcher = () => {
        const [isSatellite, setIsSatellite] = useState(false);
        const map = useMapEvents({
            zoomend: () => {
                const zoom = map.getZoom();
                setIsSatellite(zoom >= 17); // Use satellite when zoom >= 17
            }
        });

        return (
            <>
                {!isSatellite && (
                    <TileLayer
                        attribution='&copy; OpenStreetMap contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        maxZoom={22}
                    />
                )}
                {isSatellite && (
                    <TileLayer
                        attribution="Map data &copy; Google"
                        url="https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}"
                        subdomains={['mt0', 'mt1', 'mt2', 'mt3']}
                        maxZoom={22}
                    />
                )}
            </>
        );
    };




    return (
        <>


            <div style={{ height: '500px', width: '100%' }}>
                <MapContainer center={[18.5615, 73.7685]} zoom={15} maxZoom={22} style={{ height: '100%', width: '100%' }}>
                    <SatelliteLayerSwitcher />

                    <FlyToCenter center={mapCenter} />

                    {selectedCoordinates &&
                        selectedCoordinates.map((pos, idx) => (
                            <>
                                <Marker key={idx} position={pos.StartCoordinates}>
                                    <Popup>({pos.StartCoordinates[0]} ,{pos.StartCoordinates[1]} )</Popup>
                                </Marker>

                                <Marker key={idx} position={pos.EndCoordinates}>
                                    <Popup>({pos.EndCoordinates[0]} ,{pos.EndCoordinates[1]} )</Popup>
                                </Marker>
                            </>
                        ))
                    }

                    {selectedCoordinates &&
                        selectedCoordinates.map((val, index) => {
                            const type = val.ConstructionType;

                            const pathColor =
                                type === "Road" ? "green" :
                                    type === "Metro" ? "red" :
                                        type === "Water" ? "aqua" :
                                            type === "Drainage" ? "brown" :
                                                "orange";

                            const weight = type === "Metro" ? 4 : 2;
                            const dashArray = type === "Metro" ? "10,10" :
                                type === "Drainage" ? "2,6" : undefined;

                            return (
                                <React.Fragment key={index}>
                                    <Marker position={val.StartCoordinates}>
                                        <Popup>{type} Start: ({val.StartCoordinates[0]}, {val.StartCoordinates[1]})</Popup>
                                    </Marker>

                                    <Marker position={val.EndCoordinates}>
                                        <Popup>{type} End: ({val.EndCoordinates[0]}, {val.EndCoordinates[1]})</Popup>
                                    </Marker>

                                    {/* <Polygon
                                        positions={val.Area}
                                        pathOptions={{
                                            color: "orange",
                                            weight: 2,
                                            fillOpacity: 0.8
                                        }}
                                    >
                                        <Popup>Proposed Area : {val.ProposalID}</Popup>
                                    </Polygon> */}

                                    <Polygon
                                        positions={val.TechnicalSanctionArea}
                                        pathOptions={{
                                            color: pathColor,
                                            weight: weight,
                                            fillOpacity: 0.4,
                                            dashArray: dashArray
                                        }}
                                    >
                                        <Popup><div>
                                            <p><strong>Technical Sanction Work</strong></p>
                                            <p>Work Name : {val.ProposalID}</p>
                                            <p>Work Type : {val.ConstructionType} Line</p>

                                        </div></Popup>
                                    </Polygon>

                                    {val.ExactPoint.map((coord, i) => (
                                        <Marker
                                            key={`tsa-marker-${index}-${i}`}
                                            position={coord}
                                            icon={greenIcon}
                                        >
                                            <Popup>Point {i + 1}: ({coord[0]}, {coord[1]})</Popup>
                                        </Marker>
                                    ))}
                                </React.Fragment>
                            );
                        })
                    }

                    {/* {
                        FetchedCoordinates &&
                        FetchedCoordinates.map((val, index) => (
                            <Polygon
                                key={index}
                                positions={val.Area}
                                pathOptions={{ color: 'blue', weight: 2, fillOpacity: 0.6 }}
                            >
                                <Popup>{val.ProposalID}</Popup>
                            </Polygon>
                        ))
                    } */}

                    {
                        selectedCoordinates &&
                        selectedCoordinates.map((val, index) => (
                            <Polygon
                                key={index}
                                positions={val.Area}
                                pathOptions={{ color: 'orange', weight: 2, fillOpacity: 0.8 }}
                            >
                                <Popup>
                                    <div>
                                        <p><strong>Proposed Work</strong></p>
                                        <p>Work Name : {val.ProposalID}</p>
                                        <p>Work Type : {val.ConstructionType} Line</p>
                                    </div>
                                </Popup>
                            </Polygon>
                        ))
                    }


                    {Object.entries(groupedProgress).map(([key, group], idx) => (
                        <Marker
                            key={`progress-group-${idx}`}
                            position={group[0].Location}
                            icon={redIcon}
                        >
                            <Popup>
                                <div className='col-12' style={{ textAlign: 'center' }}>
                                    <p><strong>Proposal:</strong> {id}</p>

                                    <div className="row">
                                        {group.map((item, i) => (
                                            <div className="col-5" key={`image-${i}`} style={{ marginBottom: '10px' }}
                                                onClick={() => setSelectedImage(`${apiurl}/uploads/${item.Upload}`)}>
                                                <img
                                                    src={`${apiurl}/uploads/${item.Upload}`}
                                                    alt={`Progress Upload ${i + 1}`}
                                                    style={{ width: '100%', maxHeight: '150px', objectFit: 'contain' }}

                                                />
                                            </div>
                                        ))}
                                    </div>


                                </div>
                            </Popup>
                        </Marker>
                    ))}



                </MapContainer>


                <div className="col-12 text-center mt-4">
                    <button className='btn btn-danger px-4 mx-4' onClick={() => nav(`/AdminDashboard/ProgressReportInwardsList`)}>Go Back</button>
                </div>

            </div>


            {/* Modal or preview */}
            {selectedImage && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    backgroundColor: "rgba(0,0,0,0.7)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 1000
                }}
                    onClick={() => setSelectedImage(null)}
                >
                    <img
                        src={selectedImage}
                        alt="Uploaded"
                        style={{ maxWidth: "80%", maxHeight: "80%", borderRadius: '10px', boxShadow: '0 0 10px white' }}
                    />
                </div>
            )}



        </>
    )
}

export default ShowMapProgressReport;